import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { useSiteContent, getSection } from "../../context/SiteContentContext";

const FALLBACK = {
    eyebrow: "Perguntas frequentes",
    title_pre: "Tudo o que precisas",
    title_highlight: "de saber.",
    items: [
        {
            question: "Como chega a encomenda congelada?",
            answer: "Enviamos em transporte refrigerado a -18 °C, com entrega em 24–48h em Portugal continental. A polpa chega perfeitamente congelada, pronta a guardar.",
        },
        {
            question: "Quanto tempo dura no congelador?",
            answer: "Até 12 meses a -18 °C sem perder sabor nem nutrientes. Depois de descongelada, deve ser consumida em 24 horas.",
        },
        {
            question: "Como preparo o sumo?",
            answer: "Descongela a dose 2–3 minutos, junta água, leite ou bebida vegetal e mexe. Pronto em 30 segundos — cada página de sabor tem mini-receitas.",
        },
        {
            question: "Tem açúcar adicionado ou conservantes?",
            answer: "Não. É 100% fruta, congelada no próprio dia da colheita. Sem açúcares adicionados, corantes ou conservantes.",
        },
        {
            question: "Posso vender Sabor Líquido no meu café ou restaurante?",
            answer: "Sim! Temos condições B2B com margens de 30–40% e um kit de amostras grátis para começar. Vê a página Parceiros.",
        },
    ],
};

export const FAQ = () => {
    const { content } = useSiteContent();
    const cms = getSection(content, "faq", {});
    const c = { ...FALLBACK, ...cms };
    const items = c.items?.length ? c.items : FALLBACK.items;

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-20 md:py-28 bg-brand-cream"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                        {c.eyebrow}
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl text-brand-ink leading-tight">
                        {c.title_pre}{" "}
                        <span className="italic text-brand-orange">
                            {c.title_highlight}
                        </span>
                    </h2>
                </div>
                <Accordion
                    type="single"
                    collapsible
                    className="mt-10 space-y-3"
                    data-testid="faq-accordion"
                >
                    {items.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="rounded-2xl bg-white px-6 border-none shadow-soft data-[state=open]:shadow-pop transition-shadow"
                        >
                            <AccordionTrigger className="font-display font-medium text-lg text-brand-ink text-left hover:no-underline py-5">
                                {f.question}
                            </AccordionTrigger>
                            <AccordionContent className="text-brand-ink-soft text-base leading-relaxed pb-5">
                                {f.answer}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
